import { BadRequestApiError, NotFoundApiError, UnauthorizedApiError } from '~/App/utils/api'

import LoadingLayout from '../../../components/LoadingLayout'
import NotFoundPage from '../../../pages/404'
import { useAuth } from '../../AuthProvider'

const LoadingAuth: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { loading, loaded, error } = useAuth()

  if (loading) {
    return <LoadingLayout />
  }

  if (
    error instanceof BadRequestApiError ||
    error instanceof UnauthorizedApiError ||
    error instanceof NotFoundApiError
  ) {
    return <NotFoundPage />
  }

  if (error) {
    throw error
  }

  if (!loaded) {
    return <NotFoundPage />
  }

  return children
}

export default LoadingAuth
